<template>
  <!-- Render the analog or digital dashboard based on the active project type.
       Switching project in the header flips this instantly (no navigation). -->
  <AnalogPage v-if="isAnalogProject" />
  <HomePage v-else />
</template>

<script>
import { mapGetters } from "vuex";
import HomePage from "@/views/HomePage.vue";
import AnalogPage from "@/views/AnalogPage.vue";

export default {
  name: "DashboardPage",
  components: {
    HomePage,
    AnalogPage,
  },
  computed: {
    ...mapGetters("project", ["isAnalogProject"]),
  },
};
</script>
